import { createFileRoute } from '@tanstack/react-router'
import CompleteProfilePage from '@/spa/pages/CompleteProfilePage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/complete-profile')({
  component: CompleteProfilePage,
  errorComponent: routeErrorComponent,
})
